<template>
  <div>
    <div class="stats">
      <div class="stats-box average">
        <span class="value" v-show="statsLoading">
          <i class="fa fa-circle-notch fa-spin"></i>
        </span>
        <span class="value" v-show="!statsLoading">
          <i class="fa fa-star"></i>{{ stats.average }}
        </span>
        <span class="label">{{ $t('provider.reviews.average') }}</span>
      </div>

      <div class="stats-box five-star">
        <span class="value" v-show="statsLoading">
          <i class="fa fa-circle-notch fa-spin"></i>
        </span>
        <span class="value" v-show="!statsLoading">{{ stats.fiveStar }}</span>
        <span class="label">{{ $t('provider.reviews.fiveStar') }}</span>
      </div>

      <div class="stats-box total">
        <span class="value" v-show="statsLoading">
          <i class="fa fa-circle-notch fa-spin"></i>
        </span>
        <span class="value" v-show="!statsLoading">{{ stats.total }}</span>
        <span class="label">{{ $t('provider.reviews.total') }}</span>
      </div>
    </div>

    <table>
      <thead>
        <th>{{ $t('provider.reviews.date') }}</th>
        <th>{{ $t('provider.reviews.name') }}</th>
        <th>{{ $t('provider.reviews.message') }}</th>
        <th>{{ $t('provider.reviews.rating') }}</th>
      </thead>
      <tbody>
        <tr v-for="review in reviews" v-show="reviews.length > 0">
          <td class="date">{{ review.created }}</td>
          <td class="name">{{ review.name }}</td>
          <td class="message">{{ review.message }}</td>
          <td class="rating">{{ review.value }}</td>
        </tr>

        <tr v-show="loading">
          <td colspan="4" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              {{ $t('provider.reviews.loading') }}
          </td>
        </tr>

        <tr v-show="reviews.length === 0 && !loading">
          <td colspan="4" class="table-block">
            {{ $t('provider.reviews.emptyState') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ApiProviderReviews from '../../modules/api/provider/reviews'

export default {
  name: 'reviews',
  props: ['active'],
  data () {
    return {
      statsLoading: false,
      loading: false,
      loaded: ''
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    stats () {
      let provider = this.$store.state.provider
      return {
        average: provider.averageReviews.toString().substring(0, 3),
        fiveStar: provider.fiveStarReviews,
        total: provider.totalReviews
      }
    },
    reviews () {
      return this.$store.state.provider.reviews
    },
    isMax () {
      return this.$store.state.provider.reviewMax
    }
  },
  methods: {
    init () {
      let self = this
      self.$store.commit('provider/resetReviews')
      self.$store.commit('provider/setReviewMax', false)
      self.$store.commit('provider/setReviewPage', 0)

      self.getReviews()

      self.statsLoading = true
      self.$store.commit('provider/resetStatsReviews')
      ApiProviderReviews.getReviewStats(self, self.$route.params.id, function (res) {
        self.statsLoading = false
      })
    },
    getReviews () {
      let self = this
      if (self.isMax || self.loading) { return }

      self.loading = true
      ApiProviderReviews.getProviderReviews(self, self.provId, function (res) {
        self.loading = false
      })
    }
  },
  watch: {
    provId: function (value) {
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId
        this.init()
      }
    },
    active (val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId
        this.init()
      }
    }
  },
  mounted () {
    // this.init()
  }
}
</script>

<style lang="scss" scoped>
.stats{
  display: flex;

  .stats-box{
    width: 35%;
    margin: 0 5px;
    padding: 15px;
    background: #eee;
    border-radius: 4px;
    box-shadow: 1px 1px 2px rgba(0,0,0, .2);
    text-align: center;
    color: #fff;

    &.average{ background: #d15757; }
    &.five-star{ background: #57d182; }
    &.total{ background: #57aad1; }
    span{
      display: block;
      line-height: 1;

      &.value{
        font-size: 32px;
        line-height: 120%;
        font-weight: 600;

        .fa{
          font-size: 24px;
          vertical-align: 4px;
          margin-right: 5px;
        }
      }
      &.label{ font-size: 14px; }
    }
  }
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.date{
          width: 150px;
          color: #999;
        }
        &.name{ width: 130px; }
        &.rating{ width: 60px; }
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{
            color: #ccc;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/Reviews.vue